import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import { GetBoardingCertificateRequest, DefaultService as api } from 'src/sdk-servicing';
import { ServicingBaseClass } from '@common/components';
import {
  GetBoardingCertificateResultState,
  GetBoardingCertificateResultStore,
  resetGetBoardingCertificateResult,
  selectGetBoardingCertificateResultState,
  setGetBoardingCertificateResultFromApi,
} from '@common/store';

@Injectable()
export class GetBoardingCertificateResultStoreService extends ServicingBaseClass {
  /** 搭乗証明書取得APIのレスポンス */
  private _result$ = this._store.pipe(
    select(selectGetBoardingCertificateResultState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  /**
   * エラーが発生していない搭乗証明書取得APIのレスポンス通知
   */
  get success$(): Observable<GetBoardingCertificateResultState> {
    return this._result$.pipe(filter((state) => state.isFailure === false));
  }

  /**
   * エラーが発生している搭乗証明書取得APIのレスポンス通知
   */
  get failure$(): Observable<GetBoardingCertificateResultState> {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  constructor(private _store: Store<GetBoardingCertificateResultStore>, private api: api) {
    super();
  }

  override destroy(): void {
    this._store.dispatch(resetGetBoardingCertificateResult());
  }

  /**
   * 搭乗証明書取得APIを呼び出す
   * @param parameter 搭乗証明書取得APIのリクエストパラメータ
   */
  request(parameter: GetBoardingCertificateRequest): void {
    const call = this.api.ordersGetBoardingCertificatePost(parameter);
    this._store.dispatch(setGetBoardingCertificateResultFromApi({ call }));
  }
}
